<template>
  <div>
    <form class="form-horizontal mt-3">
      <div class="row">
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6">
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.nameKh'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    ref="father_name_kh"
                    v-model.trim="model.father_name_kh"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_name_kh') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_name_kh')"
                  >
                    {{ errors.first('father_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label required">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.nameEn'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_name_en"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid':
                        errors.has('father_name_en') ||
                        $v.model.father_name_en.$error
                    }"
                    @input="onFatherNameInput(model.father_name_en)"
                  />
                  <span
                    class="invalid-feedback"
                    v-if="fatherNameEnErrors.length > 0"
                    >{{ fatherNameEnErrors[0] }}</span
                  >
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_name_en')"
                  >
                    {{ errors.first('father_name_en') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.nationality'
                    )
                  }}
                  <i class="fas fa-spinner spin" v-if="nationality_fetch"></i>
                </label>
                <div class="col-md-8">
                  <ts-search-select
                    v-model.number="model.father_nationality_id"
                    :options="
                      nationalities.map(el => ({
                        value: el.id,
                        text: el.nationality
                      }))
                    "
                    :class="{
                      'is-invalid': errors.has('father_nationality_id')
                    }"
                  ></ts-search-select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_nationality_id')"
                  >
                    {{ errors.first('father_nationality_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t('school.academic.operation.profile_mgt.parentProfile.dob')
                }}</label>
                <div class="col-md-8">
                  <ts-date-picker-input
                    v-model="model.father_dob"
                    :class="{ 'is-invalid': errors.has('father_dob') }"
                  ></ts-date-picker-input>
                  <div class="invalid-feedback" v-if="errors.has('father_dob')">
                    {{ errors.first('father_dob') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.religion'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model="model.father_religion"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_religion') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_religion')"
                  >
                    {{ errors.first('father_religion') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.occupation'
                  )
                }}</label>
                <div class="col-md-8">
                  <!-- <ts-search-select
                    v-model.number="model.father_occupation_id"
                    :options="
                      occupations.map((el) => ({
                        value: el.occupation_id,
                        text: el.occupation_name_en,
                      }))
                    "
                    :class="{
                      'is-invalid': errors.has('father_occupation_id'),
                    }"
                  ></ts-search-select> -->
                  <Select
                    v-model="model.father_occupation_id"
                    filterable
                    allow-create
                    @on-create="handleCreateOccupation"
                    placeholder="Select"
                    style="width: 100%"
                    :loading="loading"
                    clearable
                  >
                    <Option
                      v-for="occupation in occupations"
                      :key="occupation.occupation_id"
                      :value="occupation.occupation_id"
                      :label="occupation.occupation_name_en"
                    >
                      {{ occupation.occupation_name_en }}
                    </Option>
                  </Select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_occupation_id')"
                  >
                    {{ errors.first('father_occupation_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.phoneLineOne'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_phone1"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_phone1') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_phone1')"
                  >
                    {{ errors.first('father_phone1') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.phoneLineSecond'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_phone2"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_phone2') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_phone2')"
                  >
                    {{ errors.first('father_phone2') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.email'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model="model.father_emails"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_emails') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_emails')"
                  >
                    {{ errors.first('father_emails') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.facebook'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_facebook"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_facebook') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_facebook')"
                  >
                    {{ errors.first('father_facebook') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.linkedIn'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_linked_in"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_linked_in') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_linked_in')"
                  >
                    {{ errors.first('father_linked_in') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.telegram'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_telegram"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_telegram') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_telegram')"
                  >
                    {{ errors.first('father_telegram') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t('school.academic.operation.profile_mgt.parentProfile.line')
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_line"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_line') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_line')"
                  >
                    {{ errors.first('father_line') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.weChat'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.father_wechat"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('father_wechat') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_wechat')"
                  >
                    {{ errors.first('father_wechat') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.notification'
                  )
                }}</label>
                <div class="col-md-8">
                  <div class="ts-inline-block">
                    <ts-checkbox v-model="model.father_sms">{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.sms'
                      )
                    }}</ts-checkbox>
                  </div>
                  <div class="ts-inline-block ml-2">
                    <ts-checkbox v-model="model.father_email">{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.email'
                      )
                    }}</ts-checkbox>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label"></label>
                <div class="col-md-8">
                  <div class="ts-inline-block">
                    <ts-checkbox v-model="model.father_allow_pickup">{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.autoCreateCard'
                      )
                    }}</ts-checkbox>
                  </div>
                  <div class="ts-inline-block ml-2"></div>
                </div>
              </div>
              <div class="row form-group pt-2">
                <label class="col-md-3 col-form-label"></label>
                <div class="col-md-8">
                  <ts-checkbox
                    v-model="model.father_login"
                    @change="onIsFatherLogin"
                    >{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.autoCreateLoginName'
                      )
                    }}</ts-checkbox
                  >
                </div>
              </div>
              <div class="row form-group pt-3">
                <label class="col-md-3 col-form-label">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.loginName'
                    )
                  }}
                  <span class="validate" v-if="model.father_login">*</span>
                </label>
                <div class="col-md-8">
                  <input
                    v-model="model.father_login_name"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid':
                        errors.has('father_login_name') ||
                        $v.model.father_login_name.$error
                    }"
                  />
                  <span
                    class="invalid-feedback"
                    v-if="fatherLoginNameErrors.length > 0"
                    >{{ fatherLoginNameErrors[0] }}</span
                  >
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('father_login_name')"
                  >
                    {{ errors.first('father_login_name') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <ts-image-input
                :file="file"
                @input="file => (model.father_photo = file)"
                :width="175"
                :height="225"
                crop
              ></ts-image-input>
            </div>
          </div>
          <div class="row froup">
            <div class="col-md-12 text-center">
              <ts-button @click="takePicture">
                <i class="fas fa-camera mr-2"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.takePicture'
                  )
                }}
              </ts-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import WebCam from './web-cam'
export default {
  name: 'fatherForm',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      errors: new Errors(),
      loading: false,
      nationality_fetch: true,
      occupation_fetch: true,
      file: require('../../../assets/staff-default-man.png')
    }
  },
  async created() {
    this.model = this.value
    await this.setEditData()
    this.$refs.father_name_kh.focus()
  },
  validations() {
    return {
      model: {
        father_name_en: { required },
        father_login_name: {
          required: requiredIf(function(nestModel) {
            return this.model.father_login
          })
        }
      },
      form: ['model.father_name_en', 'model.father_login_name']
    }
  },
  computed: {
    ...mapState('parentProfile', [
      'nationalities',
      'occupations',
      'photoBlob',
      'edit_data'
    ]),
    fatherNameEnErrors() {
      const errors = []
      if (!this.$v.model.father_name_en.$error) return errors
      !this.$v.model.father_name_en.required && errors.push('Required')
      return errors
    },
    fatherLoginNameErrors() {
      const errors = []
      if (!this.$v.model.father_login_name.$error) return errors
      !this.$v.model.father_login_name.required && errors.push('Required')
      return errors
    }
  },
  methods: {
    ...mapActions('parentProfile', [
      'getNationality',
      'getOccupation',
      'createOccupation'
    ]),
    validateForm() {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      return isValid
    },
    takePicture() {
      this.$modal.show(
        WebCam,
        {},
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          clickToClose: false
        },
        {
          'before-close': this.getPhoto
        }
      )
    },
    async handleCreateOccupation(val) {
      this.loading = true
      try {
        const response = await this.createOccupation({
          occupation_name_en: val
        })
        this.model.father_occupation_id = response.occupation_id

        this.$toasted.success('Occupation created successfully')
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$toasted.error(error.message || 'Failed to create occupation')
      }
    },
    getPhoto() {
      this.file = this.photoBlob ? this.readBlob(this.photoBlob) : this.file
      this.model.father_photo = this.photoBlob
        ? new File([this.photoBlob], 'fatherphoto', { type: 'image/jpeg' })
        : ''
      this.$store.commit('parentProfile/SET_PHOTO_BLOB', '')
    },
    readBlob(blob) {
      return window.URL.createObjectURL(
        new Blob([blob], { type: 'image/jpeg' })
      )
    },
    onFatherNameInput(value) {
      if (value !== '' && this.model.father_login == true) {
        this.model.father_login_name = value.split(' ').join('.')
      } else {
        this.model.father_login_name = ''
      }
    },
    onIsFatherLogin(value) {
      if (value == true && this.model.father_name_en !== '') {
        this.model.father_login_name = this.model.father_name_en
          .split(' ')
          .join('.')
      } else {
        this.model.father_login_name = ''
      }
    },
    async setEditData() {
      await this.getNationality().finally(() => {
        this.nationality_fetch = false
      })
      await this.getOccupation().finally(() => {
        this.occupation_fetch = false
      })
      if (!_.isEmpty(this.edit_data)) {
        ;(this.model.student_parent_id = this.edit_data.student_parent_id),
          (this.model.father_name_kh = this.edit_data.father_name_kh),
          (this.model.father_name_en = this.edit_data.father_name_en),
          (this.model.father_nationality_id = this.edit_data.father_nationality_id),
          (this.model.father_religion = this.edit_data.father_religion),
          (this.model.father_dob = this.edit_data.father_dob),
          (this.model.father_occupation_id = this.edit_data.father_occupation_id),
          (this.model.father_photo = this.edit_data.father_photo),
          (this.model.father_phone1 = this.edit_data.father_phone1),
          (this.model.father_phone2 = this.edit_data.father_phone2),
          (this.model.father_emails = this.edit_data.father_emails),
          (this.model.father_facebook = this.edit_data.father_facebook),
          (this.model.father_linked_in = this.edit_data.father_linked_in),
          (this.model.father_telegram = this.edit_data.father_telegram),
          (this.model.father_line = this.edit_data.father_line),
          (this.model.father_wechat = this.edit_data.father_wechat),
          (this.model.father_sms = this.edit_data.father_sms),
          (this.model.father_email = this.edit_data.father_email),
          (this.model.father_login = this.edit_data.father_login),
          (this.model.father_login_name = this.edit_data.father_login_name),
          (this.model.father_allow_pickup = this.edit_data.father_allow_pickup)
        this.file = this.model.father_photo
      }
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    clear: function(value) {
      if (value == true) {
        this.model = this.value
        this.file = ''
        // this.file = require('../../../assets/staff-default-man.png')
      }
    }
  }
}
</script>
<style lang="css" scoped>
.file-input-container {
  width: 174px !important;
  margin: 0 auto;
  border: 1px solid #eaeaea;
  padding: 4px;
  border-radius: 5px;
}
</style>
